<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <!-- 错误图标 -->
      <div class="mb-8">
        <el-icon class="text-red-500" :size="80"><CircleCloseFilled /></el-icon>
      </div>
      
      <!-- 错误状态码 -->
      <h1 class="text-6xl font-semibold text-gray-900 mb-4">
        {{ status }}
      </h1>
      
      <!-- 错误信息 -->
      <p class="text-xl text-gray-600 mb-8">
        {{ errorMessage }}
      </p>
      
      <!-- 返回按钮 -->
      <el-button type="primary" size="large" @click="goHome">
        <template #icon>
          <el-icon><HomeFilled /></el-icon>
        </template>
        {{ $t('error.goHome') }}
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { CircleCloseFilled, HomeFilled } from '@element-plus/icons-vue'

const { t } = useI18n()

const props = defineProps({
  status: {
    type: Number,
    default: 500
  },
  message: {
    type: String,
    default: ''
  }
})

// 获取错误消息
const errorMessage = computed(() => {
  if (props.message) return props.message
  return t(`error.messages.${props.status}`) || t('error.messages.default')
})

const goHome = () => {
  router.visit('/')
}
</script>